/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { VApplication } from "../../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { UPDATE_COSTUME_TYPE, GET_COSTUME_TYPE } from "../graphql";

const log: any = LoggerModule?.getInstance();
const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface ICostumeInventoryMethods extends IPluginMethodMap {
  updateCostumeInventory(args: any): Promise<any>;
  getCostumeType(id: string): Promise<any>;
}

export class CostumeInventoryService implements IAgentPlugin {
  readonly methods: ICostumeInventoryMethods;

  constructor() {
    this.methods = {
      updateCostumeInventory: this.updateCostumeInventory.bind(this),
      getCostumeType: this.getCostumeType.bind(this),
    };
  }

  async getCostumeType(id: string) {
    log.blue(`CostumeInventory getCostumeType:`, id);
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      if (client) {
        const res = await client.query({
          query: GET_COSTUME_TYPE,
          variables: {
            filter: {
              _id: id,
            },
          },
          fetchPolicy: "network-only",
        });
        if (res?.data) {
          return res.data.getCostumeType;
        }
      }
    } catch (err: any) {
      log.error("Error fetching costume type details:", err);
      throw err;
    }
  }

  async updateCostumeInventory(args: any) {
    log.blue(`CostumeInventory server component:`, args);
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      if (client) {
        log.blue(`inviteUser server component222:`, args);
        const res = await client.mutate({
          mutation: UPDATE_COSTUME_TYPE,
          variables: {
            filter: args.filter,
            update: args.update,
          },
          fetchPolicy: "no-cache",
        });
        if (res?.data) {
          return {
            ...res?.data?.updateCostumeType,
          };
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }
}